import { render, staticRenderFns } from "./create-password.vue?vue&type=template&id=9ebe5b44&"
import script from "./create-password.vue?vue&type=script&lang=js&"
export * from "./create-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports